//@flow
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';

import HyperText from '../HyperText';

type InfoDetailProps = {
  text: string,
  linkUrl: ?string,
  linkText: ?string,
  containerStyle: ?any,
  textStyle: ?any,
  style: ?any,
};

export const InfoDetailText = ({ containerStyle, linkText, linkUrl, text, textStyle }: InfoDetailProps) => (
  <View style={[styles.infoDetailContainer, containerStyle]}>
    <Text style={[styles.text, textStyle]}>{text}</Text>
    {!!linkUrl && !!linkText && <HyperText url={linkUrl}>{linkText}</HyperText>}
  </View>
);

const styles = StyleSheet.create({
  infoDetailContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 45,
  },
  text: {
    textAlign: 'center',
  },
});
